import * as React from 'react'
import { Connect } from '@selkirk-systems/state-management';
import SummaryStore from '@@/stores/SummaryStore';
import Typography from '@@/components/General/Typography';
import { Column, Row } from '@selkirk-systems/layout';
import { Skeleton } from 'primereact/skeleton';

class SummaryTable extends React.Component{


    static subscribe=[SummaryStore];


    static defaultProps={
        //This drives the table 'like' column spacing and layout for active, yeartoDate, previousYear,etc
        xs:"minmax(auto,60px) minmax(auto,200px) minmax(auto,200px) minmax(auto,200px)"
    }


    static storeStateToProps={
        summaries:( props,state )=>state.summaries
    }


    render(){

        const {summaries,xs,...other} = this.props;


        if(!summaries) return (
            <Column gap='sm'>
            {
                [...new Array(4)].map((item,i)=>{
                    return (
                        <Skeleton key={i} width="100%" height="85px"/>
                    )
                })
            }
            </Column>
        )

        return (
            <>
                <Row gap='md' align='top' p='md' pl='lg' pr='lg' xs="1fr" sm='260px 1fr'>
                    <div></div>
                    <Row gap='sm' xs={xs} className='row table-header'>
                        <Typography className='col-header' variant='h6'>Active</Typography>
                        <Typography className='col-header' variant='h6'>Year To Date</Typography>
                        <Typography className='col-header' variant='h6'>Previous Year To Date</Typography>
                        <Typography className='col-header' variant='h6'>5 Year Average To Date</Typography>
                    </Row>
                </Row>
                {
                summaries.map((row)=>{
                    return (
                        <Row key={row.type} name={row.type} className="section" gap='md' align='top' p='md' pl='lg' pr='lg' xs="1fr" sm='260px 1fr'>
                            <Column gap='xs'>
                                <Typography variant='h6'>{row.type}</Typography>
                                <span className="relative">
                                    <Typography variant='subtitle1' className='text-secondary'>{row.description}</Typography>
                                </span>
                            </Column>
                            <Row gap='sm' xs={xs} className='row table-row'>
                                <Typography name='activeCount'  variant='h6'>{row.activeCount}</Typography>
                                <Typography  name="yearToDateCount" variant='h6'>{row.yearToDateCount}</Typography>
                                <Typography  name="previousYearToDateCount" variant='h6'>{row.previousYearToDateCount}</Typography>
                                <Typography  name="fiveYearAverageCount" variant='h6'>{row.fiveYearAverageCount}</Typography>
                            </Row>
                        </Row>
                    )
                })}
            </>
        )
    }

}


export default Connect( SummaryTable );